export default "__VITE_ASSET__diciWs_m__"